<template>
  <div id="Logout">
    <Loader class="info lg" />
    <h2>
      {{ $t('loggingOut') }}
    </h2>
  </div>
</template>

<script>
import { actions } from '@utils'

export default {
  methods: actions('LOGOUT'),
  async beforeMount() {
    await this.LOGOUT()
    this.$router.push({ name: 'Login' })
  },
}
</script>

<style lang="scss">
#Logout {
  text-align: center;
}
</style>

<i18n>
{
  "en": {
    "loggingOut": "Logging out..."
  }
}
</i18n>
